// removed by extract-text-webpack-plugin
module.exports = {"field":"form__field-35dAI"};


//////////////////
// WEBPACK FOOTER
// ./components/auth/login/form/login-form.css
// module id = 789
// module chunks = 0